/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {Helmet} from 'react-helmet'
import {DomainListToolbar} from './components/header/DomainListToolbar'
import Searchbar from 'app/components/Searchbar'

type Props = {
  className: string
}

const Domain: React.FC<Props> = ({className}) => {
  const [searchTerm, setSearchTerm] = useState('')
  const [isDropdownVisible, setDropdownVisible] = useState(false)

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible)
  }

  return (
    <>
      <Helmet>
        <title>SecureSlate | Vulnerabilities</title>
      </Helmet>

      <div className='card-header border-0 pt-6 h-100'>
        <div className='card-title'>
        <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>
        <div className='card-toolbar'>
          <DomainListToolbar />
        </div>
      </div>
      <div className='card-body py-3 '>
        <div className='table-responsive' style={{height: '55vh', overflowY: 'auto'}}>
          <table className='table align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold fs-7 border-bottom border-dotted' style={{color: '#5A5A5A'}}>
                <th className='ps-4 min-w-300px rounded-start'>DOMAIN NAME</th>
                <th className='min-w-300px'>LOCATION</th>
                <th className='min-w-100px'>SEVERITY</th>
                <th className='min-w-100px'>OPEN</th>
                <th className='min-w-100px'>IGNORED</th>
                <th className='min-w-100px'>LAST SCAN</th>
                <th className='min-w-50px text-end rounded-end'></th>
              </tr>
            </thead>
            <tbody>
              <tr className=' border-bottom border-dotted'>
                <td>
                  <div className='d-flex align-items-center mx-5'>https://api-gateway.io</div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>cloud-instance-4</div>
                </td>
                <td>
                  <div className='d-flex align-items-center text-danger'>
                    <i className='bi bi-exclamation-triangle mx-1 text-danger'></i>
                    Low
                  </div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>3</div>
                </td>
                <td>
                  <div className='d-flex align-items-center'>0</div>
                </td>

                <td>
                  <div className='d-flex align-items-center'>12 hours ago</div>
                </td>
                <td>
                  <div className='dropdown mx-2'>
                    <button
                      className='btn btn-secondary border-0 p-0 m-2'
                      type='button'
                      id='dropdownMenu2'
                      data-bs-toggle='dropdown'
                      aria-haspopup='true'
                      aria-expanded='false'
                    >
                      <img
                        src='/media/buttons/Options.svg'
                        alt='Options'
                        onClick={toggleDropdown}
                      />
                    </button>
                    <ul className='dropdown-menu' aria-labelledby='dropdownMenu2'>
                      <li>
                        <button
                          className='dropdown-item'
                          type='button'
                          // onClick={() => handleViewClick(policyData)}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='icon icon-tabler icons-tabler-outline icon-tabler-shield-search me-2'
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.539 1.832 .627 3.747 .283 5.588' />
                            <path d='M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0' />
                            <path d='M20.2 20.2l1.8 1.8' />
                          </svg>
                          Start scan
                        </button>
                      </li>
                      <li>
                        <button
                          className='dropdown-item'
                          type='button'
                          // onClick={(e) => handleDownloadClick(policyData)}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            className='icon icon-tabler icons-tabler-outline icon-tabler-edit me-2'
                          >
                            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                            <path d='M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1' />
                            <path d='M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z' />
                            <path d='M16 5l3 3' />
                          </svg>
                          Edit configuration
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export {Domain}
